<script setup lang="ts">
import UiDialog from './components/ui/UiDialog.vue'
import { Toaster } from 'vue-sonner'
import UiBottomSheet from './components/ui/bottomsheet/UiBottomSheet.vue'
import { useTitleI18n } from './composables/useTitleI18n'

// Ensures document.title is localized.
useTitleI18n()
</script>
<template>
  <!-- Global vue-sonner configuration. -->
  <Toaster
    position="top-center"
    :duration="1500"
    :toastOptions="{
      unstyled: true,
      classes: {
        toast: 'bg-[#2A2A2A] rounded-full p-[16px] border-0 max-w-fit m-auto left-0 right-0',
        title: 'text-[16px] font-[500] leading-[22px] text-white'
      }
    }"
  />

  <!-- Global ui dialog placement. -->
  <UiDialog />

  <!-- Global ui bottom sheet placement. -->
  <UiBottomSheet />

  <div class="max-w-md m-auto min-h-full">
    <router-view />
  </div>
</template>
